// Components==============
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMeasure } from 'hooks/useMeasure';
import { useOnClickOutside } from 'hooks/useOnClickOutside';
import React, { useEffect, useRef, useState } from 'react';
import './Modal.module.scss';
// =========================

function ModalWrapper({ children }: { children: React.ReactNode }) {
  const [isOverflown, setIsOverflown] = useState(false);
  const scrollRef = useRef<HTMLDivElement>(null);
  const modalRef = useRef<HTMLDivElement>(null);

  const { height } = useMeasure(modalRef);

  useEffect(() => {
    if (
      scrollRef.current &&
      scrollRef.current.scrollHeight > scrollRef.current.clientHeight
    )
      return setIsOverflown(true);

    setIsOverflown(false);
  }, [height]);

  return (
    <>
      <div styleName="scroll-container" ref={scrollRef}>
        <div
          // {...framerFade}
          styleName="container"
          style={{
            top: isOverflown ? 0 : '50%',
            transform: isOverflown
              ? 'translate(-50%, 0)'
              : 'translate(-50%, -50%)',
          }}
          ref={modalRef}
        >
          {children}
        </div>
      </div>
      <div styleName="shader" />
    </>
  );
}

export default function Modal({
  children,
  secondChildren,
  variant = 'default',
  setModalIsOpen,
  noPadding,
  noOverflow,
  media,
}: {
  children: React.ReactNode;
  secondChildren?: React.ReactNode;
  variant?: 'default' | 'small' | 'double';
  setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  noPadding?: boolean;
  noOverflow?: boolean;
  media?: string;
}) {
  const refSmall = useRef<HTMLDivElement>(null);
  const refDefault = useRef<HTMLDivElement>(null);

  useOnClickOutside({
    handler: () => setModalIsOpen(false),
    refs: [refSmall, refDefault],
  });

  if (variant === 'double')
    return (
      <ModalWrapper>
        <div styleName="double-wrapper">
          <div styleName="small-modal" ref={refSmall}>
            {secondChildren}
          </div>
          <div styleName="default-modal modal" ref={refDefault}>
            {children}
          </div>
        </div>
        <FontAwesomeIcon
          onClick={() => setModalIsOpen(false)}
          styleName="close"
          icon={faTimes}
        />
      </ModalWrapper>
    );

  return (
    <ModalWrapper>
      <div
        styleName={`wrapper modal ${variant === 'small' ? 'small' : ''} ${
          noOverflow ? 'no-overflow' : ''
        }`}
        ref={refDefault}
      >
        {!!media && (
          <div styleName="image-wrapper">
            <img styleName="image" src={media} alt="media" />
          </div>
        )}
        <div styleName="content" style={{ padding: noPadding ? 0 : '' }}>
          {children}
        </div>
        <FontAwesomeIcon
          onClick={() => setModalIsOpen(false)}
          styleName="close"
          icon={faTimes}
        />
      </div>
    </ModalWrapper>
  );
}
